import React from "react";
import UmbronaLogo from "../../../../assets/windTree/images/nav/Umbrona.png";

const Shoploader = () => {
  return (
    <div className="preloader" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(145deg, #fafaf8 0%, #ffffff 100%)',
      zIndex: 9999
    }}>
      
      <style>{`
        /* === LOADER SPECIFIC ANIMATIONS === */
        
        @keyframes heartbeat {
          0% {
            transform: scale(1);
            filter: drop-shadow(0 10px 18px rgba(102,148,75,0.28)) brightness(1);
          }
          14% {
            transform: scale(1.12);
            filter: drop-shadow(0 15px 35px rgba(102,148,75,0.9)) brightness(1.4);
          }
          28% {
            transform: scale(1);
            filter: drop-shadow(0 12px 30px rgba(102,148,75,0.6)) brightness(1.2);
          }
          42% {
            transform: scale(1.2);
            filter: drop-shadow(0 20px 50px rgba(102,148,75,1.2)) brightness(1.8);
          }
          70% {
            transform: scale(1);
            filter: drop-shadow(0 10px 25px rgba(102,148,75,0.4)) brightness(1);
          }
          100% {
            transform: scale(1);
            filter: drop-shadow(0 10px 18px rgba(102,148,75,0.28)) brightness(1);
          }
        }

        @keyframes heartbeatPulse {
          0% { transform: scale(0.9); opacity: 0.6; }
          14% { transform: scale(1.4); opacity: 0.3; }
          28% { transform: scale(0.9); opacity: 0.6; }
          42% { transform: scale(1.6); opacity: 0.2; }
          70% { transform: scale(0.9); opacity: 0.6; }
          100% { transform: scale(0.9); opacity: 0.6; }
        }
        
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
          100% { transform: translateY(0px); }
        }
        
        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes intenseBreathing {
          0% { text-shadow: 0 0 12px rgba(102,148,75,0.3); }
          50% { text-shadow: 0 0 35px rgba(102,148,75,0.8), 0 0 25px rgba(255,255,255,1); }
          100% { text-shadow: 0 0 12px rgba(102,148,75,0.3); }
        }
        
        @keyframes dancingDots {
          0% { content: ''; }
          25% { content: '.'; }
          50% { content: '..'; }
          75% { content: '...'; }
          100% { content: ''; }
        }
        
        /* === LOADER ANIMATIONS === */
        @keyframes rotateLoader {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes slideBar {
          0% { left: -100%; }
          50% { left: 100%; }
          100% { left: -100%; }
        }
        
        .loader-container {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 25px;
        }
        
        .logo-wrapper {
          position: relative;
          z-index: 30;
          animation: float 6s ease-in-out infinite;
        }
        
        .logo-img {
          width: 110px;
          height: 110px;
          display: block;
          position: relative;
          object-fit: contain;
          animation: heartbeat 1.8s cubic-bezier(0.5, 0, 0.5, 1) infinite;
          transition: all 0.2s ease;
          filter: drop-shadow(0 8px 35px rgba(102,148,75,0.4));
        }
        
        // .loader-ring {
        //   position: absolute;
        //   width: 180px;
        //   height: 180px;
        //   border: 3px solid transparent;
        //   border-top: 3px solid #66944b;
        //   border-right: 3px solid #a0c48b;
        //   border-bottom: 3px solid #44683a;
        //   border-left: 3px solid #8fb373;
        //   border-radius: 50%;
        //   animation: rotateLoader 2s linear infinite;
        //   opacity: 0.6;
        // }
        
        // .loader-ring-inner {
        //   position: absolute;
        //   width: 160px;
        //   height: 160px;
        //   border: 2px solid transparent;
        //   border-top: 2px solid #cfe0c2;
        //   border-left: 2px solid #b8d3a3;
        //   border-radius: 50%;
        //   animation: rotateLoader 1.5s linear infinite reverse;
        //   opacity: 0.4;
        // }
        
        .loader-progress-bar {
          position: relative;
          width: 240px;
          height: 4px;
          background: rgba(102,148,75,0.1);
          border-radius: 10px;
          margin-top: 45px;
          overflow: hidden;
        }
        
        .loader-progress-fill {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, #8fb373, #66944b, #44683a);
          border-radius: 10px;
          animation: slideBar 2.2s cubic-bezier(0.65, 0, 0.35, 1) infinite;
          box-shadow: 0 0 15px rgba(102,148,75,0.6);
        }
        
        .progress-indicator {
          width: 240px;
          margin-top: 8px;
          color: #44683a;
          font-family: 'Inter', sans-serif;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 1px;
          text-align: left;
        }
        
        .preloader__text {
          margin-top: 35px;
          text-align: center;
        }
        
        .preloader__msg {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
          font-size: 1.5rem;
          color: #2c3e2f;
          animation: fadeInUp 1.5s cubic-bezier(0.23, 1, 0.32, 1);
          margin: 0;
          letter-spacing: 1.5px;
          font-weight: 400;
        }
        
        .highlight-text {
          color: #44683a;
          font-weight: 700;
          position: relative;
          display: inline-block;
          animation: intenseBreathing 3.5s ease-in-out infinite;
          padding: 0 8px;
          background: linear-gradient(145deg, #5f7e4e, #4d6a3b);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-shadow: 0 2px 12px rgba(102,148,75,0.4);
        }
        
        .dots {
          display: inline-block;
          font-size: 1.8rem;
          line-height: 1;
          color: #66944b;
          margin-left: 6px;
          animation: dancingDots 2.2s steps(1) infinite;
          width: 32px;
          text-align: left;
        }
        
      `}</style>

      <div className="loader-container">
        {/* LOADER RINGS */}
        {/* <div className="loader-ring"></div>
        <div className="loader-ring-inner"></div> */}
        
        {/* LOGO WITH HEARTBEAT ANIMATION - NO GREEN BACKGROUND CIRCLE */}
        <div className="logo-wrapper">
          <img 
            src={UmbronaLogo} 
            alt="Umbrona Logo" 
            className="logo-img"
          />
        </div>
      </div>
      
      <div className="preloader__text">
        <p className="preloader__msg">
          Crafted for Grand Living… 
        </p>
      </div>
      
      {/* PROGRESS BAR LOADER */}
      <div className="loader-progress-bar">
        <div className="loader-progress-fill"></div>
      </div>
      
      {/* PROGRESS INDICATOR - ONLY LOADING TEXT, NO DOT ICONS */}
      {/* <div className="progress-indicator">
        <span className="progress-step">LOADING</span>
      </div> */}
      
    </div>
  );
};

export default Shoploader;